import { Http } from '@/lib/http';

export class serviceSettingsService extends Http {
  endpoint = 'onboarder/settings/service-set-up/';

  constructor() {
    super();
  }

  fetchServices() {
    return this.httpClient().get(this.endpoint);
  }

  updateService(id, updates) {
    return this.httpClient().patch(`${this.endpoint}${id}`, updates);
  }

  createService(service) {
    console.log(service);
    return this.httpClient().post(this.endpoint, service);
  }
}
